import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import request from "../../lib/requester";
import _ from "lodash";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";

class UserNew extends Component {
  state = {
    loading: false,
    success: "",
    error: [],
    username: "",
    realname: "",
    activeflag: "",
    lovbranch: [],
    listbranch: [],
    lovrole: [],
    lovorigin: [],
    roleid: "",
    originid: "",
    branchid: "",
    updateBy: "",
    phone: "",
    selectAllBranches: false,
  };

  componentDidMount() {
    this.getDetailUser();
  }

  getDetailUser = () => {
    const { id } = this.props.match.params;
    const url = "/arman/v1/user/userupdate";
    const param = { user_id: id };

    this.setState({ loading: true });

    request.postArman(url, param, {
      success: (response) => {
        const { header, branchlov, role, origin, branch } = response.data.data;
        const user = JSON.parse(localStorage.getItem("is_user"));

        this.setState({
          loading: false,
          username: header.username,
          realname: header.realname,
          roleid: header.role_id,
          originid: header.origin,
          activeflag: header.active_flag,
          lovbranch: branchlov,
          listbranch: branch,
          lovrole: role,
          lovorigin: origin,
          updateBy: user.user_id,
          phone: header.phone,
        });
      },
      error: (err) => {
        console.error(err);
        this.setState({ loading: false });
      },
    });
  };

  showError = () => {
    const { error } = this.state;
    if (error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {error.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    const { success } = this.state;
    if (success) {
      return (
        <div className="alert alert-success" role="alert">
          {success}
        </div>
      );
    }
  };

  handleSave = () => {
    const {
      listbranch,
      username,
      realname,
      phone,
      roleid,
      activeflag,
      updateBy,
      originid,
    } = this.state;

    if (listbranch.length > 0) {
      const url = "/arman/v1/user/insert";
      const param = {
        username,
        realname,
        phone,
        role_id: roleid,
        active_flag: activeflag,
        updated_by: updateBy,
        origin: originid,
        branch: listbranch,
      };

      this.setState({ loading: true });

      request.postArman(url, param, {
        success: (response) => {
          this.setState({ loading: false, success: response.data.message });
          window.scrollTo(0, 0);
          setTimeout(() => {
            this.props.history.push("/admin/setup/userlist");
          }, 2000);
        },
        error: () => {
          window.scrollTo(0, 0);
          this.setState({
            loading: false,
            error: ["Failed to submit, please try again"],
          });
        },
      });
    } else {
      alert("Please choose a branch!");
    }
  };

  handleCancel = () => {
    this.props.history.push("/admin/setup/user/userlist");
  };

  handleChangeOrigin = (event) => {
    const { value } = event.target;
    const { lovbranch } = this.state;

    this.setState({ originid: value, listbranch: [] });

    lovbranch.forEach((item) => {
      document.getElementById(`defaultCheck_${item.org_id}`).checked = false;
    });

    // if (value === "HO") {
    //   const newListBranch = lovbranch.map((item) => ({
    //     org_id: parseInt(item.org_id),
    //   }));
    //   this.setState({ listbranch: newListBranch });

    //   lovbranch.forEach((item) => {
    //     document.getElementById(`defaultCheck_${item.org_id}`).checked = true;
    //   });
    // }
  };

  handleChangeRole = (event) => {
    this.setState({ roleid: event.target.value });
  };

  handleChangeActive = (event) => {
    this.setState({ activeflag: event.target.value });
  };

  handleClickBranch = (e) => {
    const { checked, value } = e.target;
    const { listbranch } = this.state;

    if (checked) {
      this.setState({
        listbranch: [...listbranch, { org_id: parseInt(value) }],
      });
    } else {
      const updatedList = listbranch.filter(
        (item) => item.org_id !== parseInt(value)
      );
      this.setState({ listbranch: updatedList });
    }
  };

  handleSelectAllBranches = (e) => {
    const { checked } = e.target;
    const { lovbranch } = this.state;

    this.setState({ selectAllBranches: checked });

    const updatedListBranch = checked
      ? lovbranch.map((item) => ({ org_id: parseInt(item.org_id) }))
      : [];

    this.setState({ listbranch: updatedListBranch });

    lovbranch.forEach((item) => {
      document.getElementById(`defaultCheck_${item.org_id}`).checked = checked;
    });
  };

  renderBranch = () => {
    const { lovbranch, selectAllBranches } = this.state;

    return (
      <>
        {lovbranch.map((item) => (
          <div className="col-md-4" key={item.org_id}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={item.org_id}
                onChange={this.handleClickBranch}
                id={`defaultCheck_${item.org_id}`}
              />
              <label
                className="form-check-label"
                htmlFor={`defaultCheck_${item.org_id}`}
              >
                {item.org_name}
              </label>
            </div>
          </div>
        ))}
      </>
    );
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const {
      loading,
      username,
      realname,
      originid,
      roleid,
      phone,
      activeflag,
      lovorigin,
      lovrole,
    } = this.state;

    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-header">User Information</div>
                  <div className="card-body">
                    {this.showSuccess()}
                    {this.showError()}
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="username"
                              className="col-sm-3 col-form-label"
                            >
                              Username
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                id="username"
                                name="username"
                                value={username}
                                onChange={this.handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="realname"
                              className="col-sm-3 col-form-label"
                            >
                              Realname
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                id="realname"
                                name="realname"
                                value={realname}
                                onChange={this.handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="origin"
                              className="col-sm-3 col-form-label"
                            >
                              Origin
                            </label>
                            <div className="col-sm-9">
                              <select
                                className="form-control"
                                name="originid"
                                value={originid}
                                onChange={this.handleChangeOrigin}
                              >
                                <option>- Select Origin -</option>
                                {lovorigin.map((item) => (
                                  <option value={item.origin} key={item.origin}>
                                    {item.origin}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="role"
                              className="col-sm-3 col-form-label"
                            >
                              Role
                            </label>
                            <div className="col-sm-9">
                              <select
                                className="form-control"
                                name="roleid"
                                value={roleid}
                                onChange={this.handleChangeRole}
                              >
                                <option>- Select Role -</option>
                                {lovrole.map((item) => (
                                  <option
                                    value={item.role_id}
                                    key={item.role_id}
                                  >
                                    {item.role_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="phone"
                              className="col-sm-3 col-form-label"
                            >
                              Phone
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                id="phone"
                                name="phone"
                                value={phone}
                                onChange={this.handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="active"
                              className="col-sm-3 col-form-label"
                            >
                              Active
                            </label>
                            <div className="col-sm-9">
                              <select
                                className="form-control"
                                name="activeflag"
                                value={activeflag}
                                onChange={this.handleChangeActive}
                              >
                                <option value="Y">Y</option>
                                <option value="N">N</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-8">
                          <p>
                            <b style={{ fontSize: "1.4em" }}>Branch</b> [
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.handleSelectAllBranches({
                                  target: {
                                    checked: !this.state.selectAllBranches,
                                  },
                                });
                              }}
                            >
                              {this.state.selectAllBranches
                                ? "Unselect All"
                                : "Select All"}
                            </a>
                            ]
                          </p>
                          <div className="row">{this.renderBranch()}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="form-group row">
                        <div className="col-md-6">
                          <div className="col-sm-9">
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={this.handleSave}
                            >
                              Create New
                            </button>
                            &nbsp;
                            <button
                              type="button"
                              className="btn btn-warning"
                              onClick={this.handleCancel}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={loading} />
        </section>
      </div>
    );
  }
}

export default UserNew;
